// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.link-resource {
  font-size: 21px;
  padding: 0 5px 0 5px;
}
.link-resource svg.icon {
  color: #106a90;
}
`, "",{"version":3,"sources":["webpack://./package/nextgisweb/nextgisweb/pyramid/nodepkg/link-resource/link-resource.less"],"names":[],"mappings":"AAAA;EACI,eAAA;EACA,oBAAA;AACJ;AAHA;EAKQ,cAAA;AACR","sourcesContent":[".link-resource {\n    font-size: 21px;\n    padding: 0 5px 0 5px;\n\n    svg.icon {\n        color: #106a90;\n    }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
